function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { withAlg as invalidKeyInput } from './invalid_key_input.js';
import isKeyLike, { types } from '../runtime/is_key_like.js';
import * as jwk from './is_jwk.js';
var tag = function tag(key) {
  return key === null || key === void 0 ? void 0 : key[Symbol.toStringTag];
};
var jwkMatchesOp = function jwkMatchesOp(alg, key, usage) {
  var _key$key_ops$includes, _key$key_ops;
  if (key.use !== undefined && key.use !== 'sig') {
    throw new TypeError('Invalid key for this operation, when present its use must be sig');
  }
  if (key.key_ops !== undefined && ((_key$key_ops$includes = (_key$key_ops = key.key_ops).includes) === null || _key$key_ops$includes === void 0 ? void 0 : _key$key_ops$includes.call(_key$key_ops, usage)) !== true) {
    throw new TypeError("Invalid key for this operation, when present its key_ops must include ".concat(usage));
  }
  if (key.alg !== undefined && key.alg !== alg) {
    throw new TypeError("Invalid key for this operation, when present its alg must be ".concat(alg));
  }
  return true;
};
var symmetricTypeCheck = function symmetricTypeCheck(alg, key, usage, allowJwk) {
  if (key instanceof Uint8Array) return;
  if (allowJwk && jwk.isJWK(key)) {
    if (jwk.isSecretJWK(key) && jwkMatchesOp(alg, key, usage)) return;
    throw new TypeError("JSON Web Key for symmetric algorithms must have JWK \"kty\" (Key Type) equal to \"oct\" and the JWK \"k\" (Key Value) present");
  }
  if (!isKeyLike(key)) {
    throw new TypeError(invalidKeyInput.apply(void 0, [alg, key].concat(_toConsumableArray(types), ['Uint8Array', allowJwk ? 'JSON Web Key' : null])));
  }
  if (key.type !== 'secret') {
    throw new TypeError("".concat(tag(key), " instances for symmetric algorithms must be of type \"secret\""));
  }
};
var asymmetricTypeCheck = function asymmetricTypeCheck(alg, key, usage, allowJwk) {
  if (allowJwk && jwk.isJWK(key)) {
    switch (usage) {
      case 'sign':
        if (jwk.isPrivateJWK(key) && jwkMatchesOp(alg, key, usage)) return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case 'verify':
        if (jwk.isPublicJWK(key) && jwkMatchesOp(alg, key, usage)) return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  }
  if (!isKeyLike(key)) {
    throw new TypeError(invalidKeyInput.apply(void 0, [alg, key].concat(_toConsumableArray(types), [allowJwk ? 'JSON Web Key' : null])));
  }
  if (key.type === 'secret') {
    throw new TypeError("".concat(tag(key), " instances for asymmetric algorithms must not be of type \"secret\""));
  }
  if (usage === 'sign' && key.type === 'public') {
    throw new TypeError("".concat(tag(key), " instances for asymmetric algorithm signing must be of type \"private\""));
  }
  if (usage === 'decrypt' && key.type === 'public') {
    throw new TypeError("".concat(tag(key), " instances for asymmetric algorithm decryption must be of type \"private\""));
  }
  if (key.algorithm && usage === 'verify' && key.type === 'private') {
    throw new TypeError("".concat(tag(key), " instances for asymmetric algorithm verifying must be of type \"public\""));
  }
  if (key.algorithm && usage === 'encrypt' && key.type === 'private') {
    throw new TypeError("".concat(tag(key), " instances for asymmetric algorithm encryption must be of type \"public\""));
  }
};
function checkKeyType(allowJwk, alg, key, usage) {
  var symmetric = alg.startsWith('HS') || alg === 'dir' || alg.startsWith('PBES2') || /^A\d{3}(?:GCM)?KW$/.test(alg);
  if (symmetric) {
    symmetricTypeCheck(alg, key, usage, allowJwk);
  } else {
    asymmetricTypeCheck(alg, key, usage, allowJwk);
  }
}
export default checkKeyType.bind(undefined, false);
export var checkKeyTypeWithJwk = checkKeyType.bind(undefined, true);